import { DOCUMENT, inject, Injectable } from '@angular/core';
import { OauthService } from '../oauth/oauth.service';
import { ConfigurationService } from '../configuration/configuration.service';
import { EmailService } from '../user/email.service';
import { MLoginIdService } from '../user/m-login-id.service';
import { Nullable, Optional } from '../../shared/shared.types';

export enum QUERY_PARAMS {
  state = 'state',
  doneRedirectUri = 'done_redirect_uri',
  clientId = 'client_id',
  userName = 'username',
  userId = 'user_id',
}

export interface MLoginRedirectState {
  doneRedirectUri: string;
  state: Optional<object>;
}

export interface NavigateToMLoginEvent<T> {
  url: string;
  state: T;
}

export const M_LOGIN_REDIRECT_CALLBACK_URL = 'm-login/callback';

@Injectable({
  providedIn: 'root',
})
export class MLoginNavigationService {
  private readonly document = inject(DOCUMENT);
  private readonly oauthService = inject(OauthService);
  private readonly configurationService = inject(ConfigurationService);
  private readonly emailService = inject(EmailService);
  private readonly mLoginIdService = inject(MLoginIdService);

  public navigateToMLogin(targetUrl: string, state?: any): void {
    const location = this.document.location;
    const currentUrl = location.pathname;
    const stateId = this.oauthService.generateStateId();
    const doneRedirectUri = `${currentUrl}?${QUERY_PARAMS.state}=${stateId}`;
    const redirectState: MLoginRedirectState = {
      doneRedirectUri: doneRedirectUri,
      state: state,
    }
    this.oauthService.saveStateInSessionStorage(stateId, redirectState);
    const mLoginCallbackUrl = `${location.origin}/${M_LOGIN_REDIRECT_CALLBACK_URL}?${QUERY_PARAMS.state}=${stateId}`;
    location.href = targetUrl +
      `?${QUERY_PARAMS.doneRedirectUri}=${mLoginCallbackUrl}` +
      `&${QUERY_PARAMS.clientId}=${this.configurationService.clientId}` +
      `&${QUERY_PARAMS.userName}=${this.emailService.get()}` +
      `&${QUERY_PARAMS.userId}=${this.mLoginIdService.get()}`;
  }

  public loadStateFromQueryParams(): any {
    const state = this.oauthService.getStateFromSessionStorage(QUERY_PARAMS.state);
    return state?.state || null;
  }

  public loadDoneRedirectUriFromQueryParams(): Nullable<string> {
    const redirectState = this.oauthService.peekStateFromSessionStorage(QUERY_PARAMS.state);
    if (redirectState && !redirectState.state) {
      this.oauthService.removeStateFromSessionStorage(QUERY_PARAMS.state);
    }
    return redirectState ? redirectState.doneRedirectUri : null;
  }
}
